import React from 'react';
import { Stack, Typography } from '@mui/material';
import { capitalizeFirstLetter } from 'formatters';

interface Props {
  value: Record<string, any>;
}

export const FinanceAndMenuChanges = ({ value }: Props) => {
  const { before, after } = value;
  const action = before === null && after !== null ? 'added' : 'removed';

  return (
    <Stack spacing={0.5}>
      <Typography variant="body2" fontWeight={500}>
        {`${capitalizeFirstLetter(action)}: F&I`}
      </Typography>

      <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
        {action === 'added' ? after?.summary : null}
      </Typography>
    </Stack>
  );
};
